import React, { useContext, useEffect, useMemo, useState } from "react";
import i18next from "i18next";
import { Context } from "../../../states/Store";
import EADialog from "../../../components/common/EADialog";
import { ERROR } from "../../../services/common/Constants";
import { createAttribute } from "../../../services/edge/AttributesService";
import AttributeForm from "./AttributeForm";
import { hasAttributeListItems } from "../../../services/common/AttributeUtils";
import FeedBackPopUp from "../../../components/FeedBackPopUp";
import {useRequestLoading} from "../../../components/common/hooks/useRequestLoading";
import { saveContextModelAttribute } from '../../../services/edge/ContexteService';
import ContextTypes from './Context';

const FORM_ID = "attribute-creation-form-id";

const AttributeCreateDialog = ({ bondType, isOpen, onClose, onValidateSuccess }) => {
  const { isRequestLoading, startLoading, stopLoading } = useRequestLoading();
  const [state, dispatch] = useContext(Context);
  const [isCreationDone, setIsCreationDone] = useState(false);
  const [isSelectingContext, setIsSelectingContext] = useState(false);
  const [contextModelId, setContextModelId] = useState(null);
  const [contextAttributeType, setContextAttributeType] = useState(null);
  const [isValidateDisabled, setIsValidateDisabled] = useState(false);

  useEffect(() => {
    if(bondType === "context") {
      setIsSelectingContext(true);
    } else {
      setIsCreationDone(!isOpen);
    }
  }, [isOpen, bondType]);

  const title = useMemo(() => {
    let type = bondType;
    if(!bondType) type = "partner";
    if(bondType==='context') type = "contexte";

    return i18next.t("attributes.createTitle") + " " + i18next.t(type).toLowerCase();
  }, [bondType])

  const handleCreateAttribute = async (attributeToSave) => {
    try {
      startLoading();
      if (!hasAttributeListItems(attributeToSave.type)) {
        delete attributeToSave.values;
      }
      if(bondType === 'context') {
        await saveContextModelAttribute(
          state.account.id,
          {
            ...attributeToSave,
            ctxModelId:contextModelId,
            bondType: contextAttributeType
          },
          dispatch);
      } else {
        await createAttribute(state.account.id, attributeToSave, null);
      }
      setIsCreationDone(true);
      onValidateSuccess();
    } catch (error) {
      const err =
        error?.message?.messages?.error && error?.message?.messages?.error[0];
      dispatch({
        type: "ALERT",
        alert: { type: ERROR, msg: err?.code || "INTERNAL_ERROR" },
      });
    }finally {
      stopLoading();
    }
  };

  return (
    <EADialog
      isOpen={isOpen}
      title={title}
      onCancel={() => {
        onClose();
      }}
      formId={FORM_ID}
      hasActions={!isCreationDone}
      maxWidth="popupsm"
      fullWidth
      isValidateDisabled={isValidateDisabled || isRequestLoading}
      isFeedBack={isCreationDone}
      validateBtnLabel={i18next.t("approve")}
    >
      {/* After confirm popup */}
      {isCreationDone && (
        <FeedBackPopUp
          onClick={onClose}
          imgSrc={"add_green"}
          content={i18next.t("attributes.createDone", {type: i18next.t("attributes." + bondType) + (bondType === "dossier" ? "s" : "")})}
          variant="valid"
          imgSize={"small"}
        />
      )}

      {/*For Context*/}
      {isSelectingContext&&(
        <ContextTypes
          formId={FORM_ID}
          setContextModelId={setContextModelId}
          setContextAttributeType={setContextAttributeType}
          setIsSelectingContext={setIsSelectingContext}
          setIsCreationDone={setIsCreationDone}
        />
      )}

      {/* Before confirm popup */}
      {!isCreationDone && !isSelectingContext && (
        <AttributeForm
          formId={FORM_ID}
          submitHandler={handleCreateAttribute}
          bondType={bondType}
          setIsValidateDisabled={setIsValidateDisabled}
        />
      )}
    </EADialog>
  );
};

export default AttributeCreateDialog;
